export const TOGGLE_FEATURES = {
  PELATIHAN_MANDIRI_DESKTOP_LANDING: 'enablePelatihanMandiriDesktopLanding',
  PELATIHAN_MANDIRI_DESKTOP_FOR_YOU: 'enablePelatihanMandiriDesktopForYou',
} as const
